import { IStartEndTimes } from '@/types/communal.types';
import dayjs from 'dayjs';
import moment from 'moment';

export const converTime = (dateTime: string) => {
  return dateTime.split('+')[0].replace('T', ' ');
};
export const formatTime = (dateTime: string, formatStr?: string) => {
  // const dateTimeStr = converTime(dateTime);
  // return moment(dateTimeStr).format(formatStr || 'YYYY-MM-DD HH:mm:ss');
  return formatTimeV2(dateTime, formatStr || 'YYYY-MM-DD HH:mm:ss');
};
export const utcTimeConverLocalTime = (dateTime: string, formatStr?: string) => {
  return moment(dateTime).format(formatStr || 'YYYY-MM-DD HH:mm:ss');
};
export const formatTimeV2 = (dateTime: string, formatStr?: string) => {
  return moment.parseZone(dateTime).format(formatStr);
};
export const timeConverLocalTimeByTimezoneId = (dateTime: string, timezoneId: string, formatStr?: string) => {
  return moment.tz(dateTime, timezoneId).local().format(formatStr);
};

export const convertTime = (dateTime: IStartEndTimes) => {
  const { Start, End } = dateTime;
  if (Start && End) {
    const startTime = new Date(Start);
    const endTime = new Date(End);
    if (startTime.getDate() === endTime.getDate()) {
      return formatTime(Start, 'YYYY-MM-DD HH:mm') + '--' + formatTime(End, 'HH:mm');
    }
    return formatTime(Start, 'YYYY-MM-DD HH:mm') + '--' + formatTime(End, 'YYYY-MM-DD HH:mm');
  }
  return '';
};

export const checkTimeSequence = (dateTime: IStartEndTimes) => {
  const { Start, End } = dateTime;
  if (Start && End) {
    const startTime = dayjs(Start);
    const endTime = dayjs(End);
    return startTime.isBefore(endTime);
  }
  return false;
};

export const formatObj = {
  YMDAndHms: 'YYYY-MM-DD HH:mm:ss',
};

export const setValueAsInt = (v: string) => {
  if (v === '' || v == null) {
    return '';
  }
  const n = parseInt(v, 10);
  return Number.isNaN(n) ? '' : n;
};

// 匹配所有超出 BMP 的字符（码点 > 0xFFFF）
export const emojiToHtmlEntity = (input: string): string => {
  return input.replace(/[\u{10000}-\u{10FFFF}]/ug, (match) => {
    const codePoint = match.codePointAt(0)!;
    return `&#x${codePoint.toString(16).toUpperCase()};`;
  });
};

export const formatTimeToHHMMSS = (seconds: number) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
};
